module.exports = __webpack_public_path__ + "static/logo-4aba7570184c80760913d9a55e4390c8.png";